import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Row, Card, Form, Input, Radio, Select, Space, Button, Col, Popover, Typography } from 'antd'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero } from './components'

import AddVehicleStyle from '../../styles/AddVehicle.module.css'

import {
  OTHER_THAN_COLLISION_COVERAGE_MI,
  RENTAL_REIMBURSEMENT_MI,
  VEHICLE_OWNERSHIP,
  VEHICLE_COLLISION_NJ,
  VEHICLE_COLLISION_DEDUCTIBLE_NJ,
  VEHICLE_DAYS_USAGE,
  COLLISION_COVERAGE_DAMAGE_MI,
  VEHICLE_DAYS_DRIVE_MILES
} from './AddVehicleConstants'

const { Text } = Typography
const { Option } = Select
const { TextArea } = Input

const AddVehicleNJ = ({ njVehicle, setNJVehicle, handleSubmit, validate }) => {
  const updateUserTextFields = (text, field) => {
    const clonedVehicle = { ...njVehicle }
    clonedVehicle[field] = text
    setNJVehicle(clonedVehicle)
  }
  
  return (
    <>
      <EmptyHeaderHero minHeight={true} title="Add Vehicle - New Jersey" />
      <div className={`${AddVehicleStyle["add-vehicle"]}`}>
        <p className={`${AddVehicleStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
        <Row>
          <Card className={`${AddVehicleStyle["register-card"]}`}>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Policyholder Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                    placeholder="First Name*"
                    value={njVehicle.firstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                    placeholder="Last Name*"
                    value={njVehicle.lastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                    placeholder="Policy Number*"
                    value={njVehicle.policyNumber}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["input-text"]} ${AddVehicleStyle["phone-number"]}`}
                    mask="(999) 999-9999"
                    onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                    placeholder="Phone Number*"
                    value={njVehicle.phoneNumber}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      setNJVehicle({
                        ...njVehicle,
                        streetAddress: event.target.value
                      })
                    }}
                    placeholder="Street Address*"
                    value={njVehicle.streetAddress}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    maxLength={5}
                    onChange={event => {
                      setNJVehicle({
                        ...njVehicle,
                        zipCode: event.target.value.replace(/\D/g, '')
                      })
                    }}
                    placeholder="Zip Code*"
                    value={njVehicle.zipCode}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                    placeholder="Email Address*"
                    value={njVehicle.emailAddress}
                  />
                </Form.Item>
              </Col>
            </Row>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Vehicle Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.vin = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="VIN*"
                    value={njVehicle.vehicleInfo.vin}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 7 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.year = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Year*"
                        value={njVehicle.vehicleInfo.year}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 7, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.make = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Make*"
                        value={njVehicle.vehicleInfo.make}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.model = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Model*"
                        value={njVehicle.vehicleInfo.model}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.stateRegistered = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="State Vehicle will be Registered*"
                    value={njVehicle.vehicleInfo.stateRegistered}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.purchaseDate = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Date Vehicle Purchased (mm/dd/yyyy)*"
                    value={njVehicle.vehicleInfo.purchaseDate}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>In whose name will the vehicle be registered?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonFirstName = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="First Name*"
                    value={njVehicle.vehicleInfo.registeredPersonFirstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonLastName = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Last Name*"
                    value={njVehicle.vehicleInfo.registeredPersonLastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
              Number of days per week this vehicle is used to drive to work, school or public transportation site?*
            </Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.noOfDaysUsed = value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={njVehicle.vehicleInfo.noOfDaysUsed}
                  >
                    {VEHICLE_DAYS_USAGE.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>How many miles one-way?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.oneWayMiles = value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={njVehicle.vehicleInfo.oneWayMiles}
                  >
                    {VEHICLE_DAYS_DRIVE_MILES.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle owned, leased, or financed?*</Text>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.vehicleOwnership = value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={njVehicle.vehicleInfo.vehicleOwnership}
                  >
                    {VEHICLE_OWNERSHIP.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {(njVehicle.vehicleInfo.vehicleOwnership === 'Leased' ||
              njVehicle.vehicleInfo.vehicleOwnership === 'Financed') && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...njVehicle.vehicleInfo }
                        vehicleInfo.nameOfBank = event.target.value
                        setNJVehicle({
                          ...njVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Name of Bank/Leasing Company*"
                      value={njVehicle.vehicleInfo.nameOfBank}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is there a Co-Owner/Co-Buyer/Co-Lessee?*</Text>
                <Radio.Group
                  className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                  onChange={event => {
                    const vehicleInfo = { ...njVehicle.vehicleInfo }
                    vehicleInfo.isVehicleWithCoOwnership = event.target.value
                    setNJVehicle({
                      ...njVehicle,
                      vehicleInfo
                    })
                  }}
                  value={njVehicle.vehicleInfo.isVehicleWithCoOwnership}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {njVehicle.vehicleInfo.isVehicleWithCoOwnership === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...njVehicle.vehicleInfo }
                        vehicleInfo.coOwnershipPersonFirstName = event.target.value
                        setNJVehicle({
                          ...njVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="First Name*"
                      value={njVehicle.vehicleInfo.coOwnershipPersonFirstName}
                    />
                  </Form.Item>
                </Col>
                <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Input
                      autoComplete="off"
                      className={`${AddVehicleStyle["input-text"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...njVehicle.vehicleInfo }
                        vehicleInfo.coOwnershipPersonLastName = event.target.value
                        setNJVehicle({
                          ...njVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Last Name*"
                      value={njVehicle.vehicleInfo.coOwnershipPersonLastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Row>
              <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose “Other than Collision” (Comprehensive) coverage?*</Text>
              <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{OTHER_THAN_COLLISION_COVERAGE_MI}</p>} title={null}>
                <InfoCircleOutlined />
              </Popover>
            </Row>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    const vehicleInfo = { ...njVehicle.vehicleInfo }
                    vehicleInfo.otherCollisionCoverage = event.target.value
                    setNJVehicle({
                      ...njVehicle,
                      vehicleInfo
                    })
                  }}
                  value={njVehicle.vehicleInfo.otherCollisionCoverage}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {njVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                  Choose your “Other than Collision” (Comprehensive) deductible. (The standard deductible in New Jersey
                  is $750)*
                </Text>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Select
                        onChange={value => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.otherCollisionDeductible = value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Select from the following"
                        value={njVehicle.vehicleInfo.otherCollisionDeductible}
                      >
                        {VEHICLE_COLLISION_NJ.map((item, index) => (
                          <Option key={index} value={item.label}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {njVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Row>
                    <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose “Collision” coverage?*</Text>
                    <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{COLLISION_COVERAGE_DAMAGE_MI}</p>} title={null}>
                      <InfoCircleOutlined />
                    </Popover>
                  </Row>
                  <Radio.Group
                    onChange={event => {
                      const vehicleInfo = { ...njVehicle.vehicleInfo }
                      vehicleInfo.collisionCoverage = event.target.value
                      setNJVehicle({
                        ...njVehicle,
                        vehicleInfo
                      })
                    }}
                    value={njVehicle.vehicleInfo.collisionCoverage}
                  >
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            )}
            {njVehicle.vehicleInfo.collisionCoverage === 'Yes' && (
              <>
                {' '}
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                  Choose your “Collision” coverage deductible. (The standard deductible in New Jersey is $750)*
                </Text>
                <Row className={`${AddVehicleStyle["row-margin-bottom-0"]}`}>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Select
                        onChange={value => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.collisionCoverageDeductible = value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Select from the following"
                        value={njVehicle.vehicleInfo.collisionCoverageDeductible}
                      >
                        {VEHICLE_COLLISION_DEDUCTIBLE_NJ.map((item, index) => (
                          <Option key={index} value={item.label}>
                            {item.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            {njVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <>
                <Row>
                  <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose Rental Reimbursement coverage?*</Text>
                  <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{RENTAL_REIMBURSEMENT_MI}</p>} title={null}>
                    <InfoCircleOutlined />
                  </Popover>
                </Row>
                <Row>
                  <Col xl={{ span: 6 }} xs={{ span: 24 }}>
                    <Radio.Group
                      className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                      onChange={event => {
                        const vehicleInfo = { ...njVehicle.vehicleInfo }
                        vehicleInfo.rentalReimbursementCoverage = event.target.value
                        setNJVehicle({
                          ...njVehicle,
                          vehicleInfo
                        })
                      }}
                      value={njVehicle.vehicleInfo.rentalReimbursementCoverage}
                    >
                      <Radio value="1">$15 per day/ $450 max</Radio>
                      <Radio value="2">$30 per day/ $900 max</Radio>
                      <Radio value="3">No</Radio>
                    </Radio.Group>
                  </Col>
                </Row>
              </>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle primarily kept overnight at the policy address?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    const vehicleInfo = { ...njVehicle.vehicleInfo }
                    vehicleInfo.isVehiclePrimarilyKeptOvernight = event.target.value
                    setNJVehicle({
                      ...njVehicle,
                      vehicleInfo
                    })
                  }}
                  value={njVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {njVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight === 'No' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Where will the vehicle be kept overnight?*</Text>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.streetAddress = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Street Address*"
                        value={njVehicle.vehicleInfo.overnightVehicleAddress.streetAddress}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.apt = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Apartment#"
                        value={njVehicle.vehicleInfo.overnightVehicleAddress.apt}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.city = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="City*"
                        value={njVehicle.vehicleInfo.overnightVehicleAddress.city}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.state = event.target.value
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="State*"
                        value={njVehicle.vehicleInfo.overnightVehicleAddress.state}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        maxLength={5}
                        onChange={event => {
                          const vehicleInfo = { ...njVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.zipCode = event.target.value.replace(/\D/g, '')
                          setNJVehicle({
                            ...njVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Zip Code*"
                        value={njVehicle.vehicleInfo.overnightVehicleAddress.zipCode}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is your vehicle being used for business purposes?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    setNJVehicle({
                      ...njVehicle,
                      isBusinessPurpose: event.target.value
                    })
                  }}
                  value={njVehicle.isBusinessPurpose}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {njVehicle.isBusinessPurpose === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <TextArea
                      autoComplete="off"
                      className={`${AddVehicleStyle["textarea-text"]}`}
                      onChange={event => {
                        setNJVehicle({
                          ...njVehicle,
                          reason: event.target.value
                        })
                      }}
                      placeholder="Please explain why*"
                      rows={4}
                      value={njVehicle.reason}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      setNJVehicle({
                        ...njVehicle,
                        effectDate: event.target.value
                      })
                    }}
                    placeholder="mm/dd/yyyy*"
                    value={njVehicle.effectDate}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Row>
        <Row className={`${AddVehicleStyle["submit-container"]}`}>
          <Form.Item className={`${AddVehicleStyle["btn-control"]} ${AddVehicleStyle["button-submit-form"]}`}>
            <Space>
              <Button className={`${AddVehicleStyle["register"]} ${AddVehicleStyle["register-form-button"]}`} disabled={validate} onClick={handleSubmit}>
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </div>
    </>
  )
}

AddVehicleNJ.propTypes = {
  handleSubmit: PropTypes.func,
  njVehicle: PropTypes.object,
  setNJVehicle: PropTypes.func,
  validate: PropTypes.func
}

export default AddVehicleNJ
